import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=1dc6b19e&scoped=true"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=1dc6b19e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc6b19e",
  null
  
)

export default component.exports